exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* prevents bg color from leaking outside the border */\n\n/* Override Bootstrap buttons */\n\n.bootstrap-agendor .datetimePicker-datetimeWrapper {\n  background: #fff;\n  padding: 5px;\n  min-height: 280px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  -ms-border-radius: 4px;\n  border-radius: 4px;\n}\n\n.bootstrap-agendor .datetimePicker-datetime {\n  padding: 5px;\n}\n\n.bootstrap-agendor .datetimePicker-date {\n  width: 115px !important;\n  margin-right: 8px;\n}\n\n.bootstrap-agendor .datetimePicker-time {\n  width: 60px !important;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/resolve-url-loader!/~/sass-loader!./app/assets/css/sass/components/datetime-picker.scss
// module id = 567
// module chunks = 0